
const getExtensionsFromMIMEString = (mimeString) => {
    const exts = mimeString.split(',').map( mime => {
        return '.' + mime.split('/')[1].trim()
    })
    return exts.join(" ")
}

export default {
    dropzone: {
        id: 'MEDCAL_RX_DROPZONE_DEFAULT_MESSAGE',
        defaultMessageHTML: {__html: '<b>Drag and drop files here</b>, or click inside this box to choose file(s) to <b>upload.</b>'},
        maxNumFiles: {
            id: 'MEDCAL_RX_MAX_FILES_UPLOAD_ERROR',
            size: 10,
            text: 'Only maximum of 10 files allowed.'
        },
        maxFileSize: {
            size: 26214400, // 25MB size limit on files
            text: 'File size cannot exceed 25mb.',
            id: 'MEDCAL_RX_DROPZONE_MAX_FILE_SIZE_ERROR'
        },
        fileTypes: (fileTypes) => {
            return `Please upload supported files: ${getExtensionsFromMIMEString(fileTypes)}`
        }
    },
    header1: 'If you are unable to upload attachments electronically, please fax your attachments to 1-800-869-4325.',
    header2: 'Please include the members first and last name, date of birth, and Medi-Cal Rx identification number on a cover page.',
    header3: 'Please attach all chart/lab note(s), invoice(s), compendia literature(s), and any other documentation deemed pertinent to establish medical necessity.',
    header4: 'This information will be used to ensure a thorough clinical review of the PA request.'
}
